import React from 'react';
import PropTypes from 'prop-types';
import { FadeLoading } from 'components/transitions';
import { STOREFRONT_CNAME_TLD } from 'constants/storefront';

const { ENTRI_APPLICATION_ID } = process.env;

export default class StorefrontDomains extends React.PureComponent {
  static contextTypes = {
    client: PropTypes.object.isRequired,
  };

  static propTypes = {
    fetchEntriToken: PropTypes.func.isRequired,
    onClose: PropTypes.func.isRequired,
  };

  state = {
    entriLoadingScript: false,
    entriLoadingToken: false,
    entriToken: null,
  };

  eventController = null;

  async componentDidMount() {
    await this.loadEntri();

    this.eventController = new AbortController();

    window.addEventListener('onEntriClose', this.props.onClose, {
      signal: this.eventController.signal,
    });
  }

  componentWillUnmount() {
    if (this.eventController) {
      this.eventController.abort();
    }
  }

  async loadEntri() {
    if (!window.entri) {
      this.setState({ entriLoadingScript: true });
      const script = document.createElement('script');
      script.setAttribute('src', 'https://cdn.goentri.com/entri.js');
      script.onload = this.onEntriScriptLoad;
      document.body.appendChild(script);
    }

    this.setState({ entriLoadingToken: true });
    const entriToken = await this.props.fetchEntriToken();
    this.setState({ entriToken, entriLoadingToken: false }, () =>
      this.launchEntri(),
    );
  }

  onEntriScriptLoad = () => {
    this.setState({ entriLoadingScript: false }, () => this.launchEntri());
  };

  launchEntri() {
    // TODO: figure out how to prefill the domain when re-configuring
    // const { domain } = this.props;
    const { entriToken, entriLoadingScript, entriLoadingToken } = this.state;

    const entriLoading = entriLoadingScript || entriLoadingToken;
    if (entriLoading) {
      return;
    }

    window.entri.showEntri({
      applicationId: ENTRI_APPLICATION_ID,
      token: entriToken,
      dnsRecords: [
        {
          type: 'CNAME',
          host: '{SUBDOMAIN}',
          value: `${this.context.client.id}.${STOREFRONT_CNAME_TLD}`,
          ttl: 300,
        },
      ],
    });
  }

  render() {
    const { entriLoadingScript, entriLoadingToken } = this.state;

    if (!entriLoadingScript && !entriLoadingToken) {
      return null;
    }

    return <FadeLoading active={true} className="view-loading-mask" />;
  }
}
